<template>
  <div>
    <header-applis titre="Personnaliser l'offre à votre profil" sous-titre="Mobiliser les raisonnements mathématiques" index-progression-courante="3"
                   index-progression-secondaire="3"/>
    <choix-competence-repeater :competences="competences" :callback="sauvegarder"/>
    <skip-competences ecrant-suivant="utiliseroutilsnumeriques"/>
    <footer-applis ecran-precedent="communiquerecrit" ecran-suivant="activitesquotidiennes" label-suivant="Je ne souhaite pas répondre aux questions"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';
import ChoixCompetenceRepeater from '../../components/ChoixCompetenceRepeater';
import SkipCompetences from '../../components/SkipCompetences';

export default {
  name: 'mobiliserraisonnements',
  components: {
    SkipCompetences,
    ChoixCompetenceRepeater,
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      competences: [{
        niveau: 1,
        valeur: 'J\'identifie les informations chiffrées ou non, présentes ou manquantes, en situation'
      }, {
        niveau: 2,
        valeur: 'J\'applique les opérations et les mesures dans des situations de calcul liées à mon environnement'
      }, {
        niveau: 3,
        valeur: 'Je choisis les raisonnements et les opérations adaptés pour répondre à des situations courantes'
      }, {
        niveau: 4,
        valeur: 'J\'élabore et confronte mes stratégies de résolution de problème dans des environnements variés'
      }]
    }
  },
  methods: {
    competencesTransversales() {
      return this.$store.getters.getCompetencesTansversales;
    },
    sauvegarder(competence) {
      let informations = {};
      Object.assign(informations, this.competencesTransversales());
      informations.mobiliserraisonnements = competence;
      this.$store.commit('setCompetencesTransversales', informations);
      this.$router.push('utiliseroutilsnumeriques');
    }
  }
}
</script>
